<template>
  
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs" >
    <z-page :title="title">
      <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess" >
        <div class="w-flex wrap smd-column " >
           <div class="grow " >
            <h1>Form Embrio</h1>
            <hr>
            <w-input class="mt4" label="Kode " type="text" v-model="form.kode" disabled/>
            <z-select class="mt4" :items="lkp_ternakan" label="Ternakan *"  v-model="form.lkp_ternakan_id" @input="getBaka(form.lkp_ternakan_id);getBakaInduk(form.lkp_ternakan_id)" :validators="[validators.required]"/>
            <w-input class="mt4" label="Tarikh " type="date" v-model="form.tarikh" />
            <z-select class="mt4" :items="user" label="Al Man "  v-model="form.user_id"  />
            <z-select class="mt4" :items="status" label="Status"  v-model="form.lkp_status_id"  />
            <z-select class="mt4" :items="jantina" label="Jantina " v-model="form.jantina"   />
            <z-select class="mt4" :items="tangki" label="Tangki " v-model="form.tangki_id"   />
            <z-money class="mt4" label="Amaun " v-model:originalValue="form.amaun" name="amaun" :validators="[validators.required]" /> 
          </div>
          <div class="mx2"></div>
          <div class="grow " >
            <h1></h1>
            <br>
            <z-select class="mt4" :items="lkp_baka" label="Baka Jantan*"  v-model="form.lkp_baka_id" @input="getBakaJantan(form.lkp_baka_id)" :validators="[validators.required]"/>
            <z-select class="mt4" :items="baka_jantan" label="Jantan *"  v-model="form.baka_id" @input="getbakaStraw(form.baka_id)" :validators="[validators.required]"/>
            <z-select class="mt4" :items="baka_straw" label="Semen *"  v-model="form.baka_straw_id"  :validators="[validators.required]"/>
            <z-select class="mt4" :items="lkp_baka_induk" label="Baka Betina *"  v-model="form.lkp_baka_induk_id " @input="getBakaBetina(form.lkp_baka_induk_id)" :validators="[validators.required]"/>
            <z-select class="mt4" :items="baka_betina" label="Betina *"  v-model="form.baka_induk_id" @input="getbakaStrawBetina(form.baka_induk_id)" :validators="[validators.required]"/>
            <z-select class="mt4" :items="baka_straw_induk" label="Sel Telur *"  v-model="form.baka_straw_induk_id"  :validators="[validators.required]"/>

        </div>

      </div>
        <w-flex class="mt3" wrap align-center justify-end>
          <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
              <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
          </w-button>
        </w-flex>
      </w-form>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
   data: [Array, Object],
   data_ternakan: [Array, Object],
   data_status: [Array, Object],
   data_user: [Array, Object],
   data_tangki: [Array, Object],
   data_lkp_baka: [Array, Object],
   data_baka_jantan: [Array, Object],
   data_baka_straw: [Array, Object],
   data_lkp_baka_induk: [Array, Object],
   data_baka_betina: [Array, Object],
   data_baka_straw_induk: [Array, Object]

  },
  data() {
    return {
      resourceurl: 'embrio',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Embrio', route: '/embrio' },
      ],
      title : 'Tambah Embrio',
      
      lkp_ternakan : this.data_ternakan,
      user : this.data_user,
      tangki : this.data_tangki,
      status: this.data_status,

      form : this.data,
      lkp_baka : this.data_lkp_baka,
      baka_jantan: this.data_baka_jantan,
      baka_straw: this.data_baka_straw,
      baka_betina: this.data_baka_betina,
      baka_straw_induk: this.data_baka_straw_induk,
      lkp_baka_induk: this.data_lkp_baka_induk,
      
      jantina: [{
         value: 1,
         label: "Jantan"
      },{
         value: 2,
         label: "Betina"
      }],


    }
  },
  methods: {
    getBaka(id){
      this.$zcomm.get(this.api_service + 'lookup/baka/'+id, {}).then(res => {
        this.lkp_baka = res
      })
      
    },
    getBakaJantan(id){
      this.$zcomm.get(this.api_service + 'lookup/baka_jantan/'+id, {}).then(res => {
        this.baka_jantan = res
      })
    },

    getbakaStraw(id){
      this.$zcomm.get(this.api_service + 'lookup/semen/'+id, {}).then(res => {
        this.baka_straw = res
        if(this.form.baka_straw_id > 0){
          this.baka_straw.push({value: this.form.baka_straw_id, label : this.form.semen})
        }
      })
    },
    getBakaBetina(id){
      this.$zcomm.get(this.api_service + 'lookup/baka_betina/'+id, {}).then(res => {
        this.baka_betina = res
      })
    },
    getBakaInduk(id){
      this.$zcomm.get(this.api_service + 'lookup/baka/'+id, {}).then(res => {
        this.lkp_baka_induk = res
      })
    },

    getbakaStrawBetina(id){
      this.$zcomm.get(this.api_service + 'lookup/sel_telur/'+id, {}).then(res => {
        this.baka_straw_induk = res
        if(this.form.baka_straw_induk_id > 0){
          this.baka_straw_induk.push({value: this.form.baka_straw_induk_id, label : this.form.sel_telur})
        }
      })
    },

    onSuccess(){
      if (this.form.id > 0) 
      {
        this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
        .then(res => {
          if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit()
          }
          // this.$inertia.visit(this.$route('embrio.show', this.form.id))
          this.$inertia.visit(this.$route('embrio.index'))
        })
      }
      else 
      {
        this.$zcomm.post(this.resourceurl+'.store' , this.form)
        .then(res => {
          if (typeof this.onAfterAdd === "function") {
            this.onAfterAdd()
          }
          // this.$inertia.visit(this.$route('embrio.show', res.id))

          this.$inertia.visit(this.$route('embrio.index'))

        })
      }
    },

    
    

  },



  watch: {

  },
  mounted() {

    
    
    if(this.form.id > 0)
    {
     
      this.title = 'Kemaskini Embrio'
    }
    else
    {
      this.title = 'Tambah Embrio'
    }
    
    
    
    // this.getStatus()
    // this.getlkpBaka()
    // this.getBaka()
    // this.getbakaStraw()
    // this.getbakaInduk()
    // this.getbakastrawInduk()
    // this.getAmaun()

    // this.getData()
  

  }
    
}
</script>
